import React from "react";


function Cards(props)
{
  return(
    <>
    <div className="card ms-4" style={{width: "18rem"}}>
        <img src={props.imgsrc} className="card-img-top" alt="..."  style={{width: '100%', height: '15vw', objectFit: 'cover'}}/>
        <div className="card-body w3-light-gray">
            <h5 className="card-title" style={{textAlign:'center'}}><b>{props.title}</b></h5>
            <p className="card-text" style={{height:'30px', textAlign:'center'}}>{props.sname}</p>
        </div>
    </div>
    </>
    )
}
export default Cards;